import React from "react";
import ProfileViewer from "../../../../Universal/Profiles/ProfileViewer.component";
import { ReactComponent as BatchIcon } from "../../../../../assets/Icons/Setting/Profile/TeamBatch.svg";

const TeamInfoCard = ({ _data, onEdit, onDelete }) => {
  return (
    <div
      className="h-fit flex-col align-left justify-start g-2 p-2 back-white radius-10"
      style={{ width: "24rem", borderTop: "8px solid var(--blueColor1)" }}
    >
      <h3 className="weight-500 t-18 poppins-medium color-textColor">
        {_data?.teamName}
      </h3>
      <div
        className="w-full flex-col align-left justify-start scroll-y pr-05"
        style={{ maxHeight: "26rem" }}
      >
        <div className="w-full flex-col align-left justify-start g-1">
          <div className="w-full flex-col align-left justify-start g-05">
            <p className="t-13 poppins color-blueColor1">
              <span className="t-13 color-textColor mr-05">Working field:</span>
              {_data?.workingField}
            </p>
            <p className="t-13 poppins color-blueColor1">
              <span className="t-13 color-textColor mr-05">Captain:</span>
              {_data?.captain}
            </p>
            <p className="t-13 poppins color-blueColor1">
              <span className="t-13 color-textColor mr-05">Team members :</span>
              {_data?.members}
            </p>
          </div>

          <div className="teamInfoMemberListSliderParent">
            <ul className="teamInfoMemberList">
              {_data?.teamMembers?.map((item, index) => (
                <li key={item?.id}>
                  <div className="flex-row align-left justify-start w-full g-05">
                    <span className="t-13 poppins color-textColor">
                      {index + 1}
                    </span>
                    <div className="teamMemberListProfiles">
                      <ProfileViewer
                        imageHeight={"3rem"}
                        imageWidth={"3rem"}
                        imageSource={item?.image}
                        name={
                          item &&
                          item?.name?.split(" ")[0] +
                            " " +
                            ((item && item?.name?.split(" ")[1]) || "")
                        }
                        _id={item?.id}
                        designation={item?.designation}
                      />

                      <div className="flex-row align-center justify-end">
                        {item?.isCaptain && <BatchIcon fill={"#FFBB00"} />}
                        {item?.isViceCaptain && <BatchIcon fill={"#3FB5FF"} />}

                        {!item?.isCaptain && !item?.isViceCaptain && (
                          <BatchIcon fill={"#A9A9A9"} />
                        )}
                      </div>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
          <button
            type="button"
            className="actionBtn w-full"
            onClick={() => onEdit(_data?.id)}
          >
            Edit
          </button>
          <button
            type="button"
            className="deleteBtnFill w-full"
            onDelete={() => onDelete(_data?.id)}
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default TeamInfoCard;
